<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "App",
  components: {
    // HelloWorld,
  },
  methods: {
    goToPage(page) {
      this.$router.push({ name: "card", parmas: { id: page.id } });
    },
  },
  apollo: {
    pages: gql`
      query {
        pages {
          title
          id,
          richText
        }
      }
    `,
  },
};
</script>
<style lang="scss">
@import './assets/App.scss'
</style>
